import { render } from "./dataSyncInit.vue?vue&type=template&id=47afff9a&scoped=true"
import script from "./dataSyncInit.vue?vue&type=script&lang=js"
export * from "./dataSyncInit.vue?vue&type=script&lang=js"

import "./dataSyncInit.vue?vue&type=style&index=0&id=47afff9a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47afff9a"]])

export default __exports__